import { ExperienceSource } from 'model/IExperience';
import { getPricePerPerson } from 'utils/getPrettyPrice';

import { formatPrice } from './formatPrice';

export const getExperienceAdvertisedPricePerPerson = (
  experience: ExperienceSource,
  currency: string,
  options: { roundPrice?: boolean } = {},
): string => {
  const roundPrice = options.roundPrice ?? false;
  const advertisedCentValue =
    experience?.pricing?.advertised_price_origin?.amount?.centValue ?? 0;
  const advertisedPrice = advertisedCentValue / 100;

  return formatPrice(advertisedPrice, currency, { rounded: roundPrice });
};

export const getExperiencePricePerPerson = (
  experience: ExperienceSource,
  nrOfAdults: number,
  nrOfChildren: number,
  currency: string,
  options: { roundPrice?: boolean } = {},
) => {
  const roundPrice = options.roundPrice ?? false;

  const perPersonPrice = getPricePerPerson(
    experience,
    nrOfAdults,
    nrOfChildren,
  );

  return formatPrice(perPersonPrice, currency, { rounded: roundPrice });
};
